<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="warea">
                    <div class="col-12 gmx_spin" style="height:90%">
                        <div class="row nav-top">
                            <div class="col-2 xtl"><span class="nav-back wt" onclick="window.location.href='#/'"></span>
                            </div>
                            <div class="col-8 tfw-7 tf-20">Circle</div>
                            <div class="col-2 xtr mcpl" @click="readrule()">Rule</div>
                        </div>
                        <div class="row mt-2 tfwr pt-2">
                            <div class="col-6 xtl">
                                <div class="tf-14 mb-2">Period</div>
                                <div class="tf-24 period" id="cpd">{{ userdetails.period }}</div>
                            </div>
                            <div class="col-6 xtr">
                                <div class="tf-16 mb-2 tfcdg">Count Down</div>
                                <div class="cd" id="demo" onclick="CRN30SP()">

                                </div>
                                <div id="cdx"></div>
                            </div>
                        </div>
                        <div class="row" style="min-height: 362px;">
                            <div class="col-12 mt-3 wlrcdb" id="rx20"
                                onclick="window.location.href='#/record?server=Wheelocity'">
                                <span v-for="row in resultrec" :key="row.id"><span
                                        :class="`wlrcd wlb ${row.clo}`"></span></span><span class="wlrcd wlb">?</span>
                            </div>
                            <div class="col-12 xtc mt-3">
                                <div class="wlarrow"></div>
                                <div class="wlwspnxb"><img class="wlxic" id="wheel"
                                        src="../assets/includes/images/circle.png" style="transform: rotate(356deg); ">
                                    <div class="wlpcity">
                                        <div class="tf-14" id="wlsmg">Place your bets</div>
                                        <div class="tf-20 pt-2 tfw-6" id="wlbamt" hidden="">0</div>
                                    </div>
                                </div>
                                <div class="wljbb" style="margin-top: 30px;">
                                    <div class="wlj wlc yellow" id="jnx2" @click="join('yellow')">Join Yellow</div>
                                    <div class="wlj wlc green" id="jnx50" @click="join('green')">Join Green</div>
                                    <div class="wlj wlc red" id="jnx3" @click="join('red')">Join Red</div>
                                    
                                </div>
                                <div style="    margin-top: 0px;
    font-size: 18px;">1:2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1:2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1:18 </div>

                                <div class="wljbb" style="margin-top: 10px;">
                                    <div class="wlj wlc black" id=""  @click="join('cow')" style="height: 50px; width: 84px;"><img src="../assets/includes/images/cow.png"  style="height: 100%;"> </div>
                                    <div class="wlj wlc red" id="" @click="join('lion')" style="height: 50px; width: 84px;"><img src="../assets/includes/images/lion.png" style="height: 100%;"> </div>
                                    <div class="wlj wlc blue" id="" @click="join('elephant')" style="height: 50px; width: 84px;"><img src="../assets/includes/images/elephant.png" style="height: 100%;" > </div>
                                    <div class="wlj wlc green" id="" @click="join('king')" style="height: 50px; width: 84px;"><img src="../assets/includes/images/crow.png" style="height: 100%;"> </div>
                                    
                                </div>
                                <div style="    margin-top: 0px;
    font-size: 18px;">&nbsp;&nbsp;&nbsp;1:3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1:3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1:3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1:18 </div>

                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-6 tfw-6 tffm tabin active" id="every" @click="everyoneorder()">Everyone's
                                Order
                            </div>
                            <div class="col-6 tfw-6 tffm tabin" id="my" @click="myorder()">My Order</div>
                            <div class="col-12" id="everyoneorder">
                                <div class="row" style="color:black;">
                                    <div class="col-4 tf-14 pt-2 xtl">Period</div>
                                    <div class="col-3 tf-14 pt-2">User</div>
                                    <div class="col-2 tf-14 pt-2">Select</div>
                                    <div class="col-3 tf-14 pt-2 xtr">Point</div>
                                </div>
                                <div class="row">
                                    <marquee direction="down" id="ev" scrollamount="3">
                                        <div class="col-12" id="wceod">
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***624</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb lion"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">50</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***820</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb cow"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">100</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***873</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb cow"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">20</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***202</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb lion"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">20000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***929</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb red"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;">red</span>
                                                </div>
                                                <div class="col-3 xtr">300</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***813</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb lion"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***709</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb cow"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">300</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***728</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb red"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;">red</span>
                                                </div>
                                                <div class="col-3 xtr">1000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***898</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb lion"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***077</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb cow"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***739</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb cow"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">20</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***831</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb red"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;">red</span>
                                                </div>
                                                <div class="col-3 xtr">500</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***513</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb lion"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">50</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***842</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb lion"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***987</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb red"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;">red</span>
                                                </div>
                                                <div class="col-3 xtr">100</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***959</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb lion"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">20</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***219</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb lion"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">12000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***788</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb cow"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">100</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***677</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb red"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;">red</span>
                                                </div>
                                                <div class="col-3 xtr">2000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***224</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb green"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;">green</span>
                                                </div>
                                                <div class="col-3 xtr">10000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***129</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb red"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;">red</span>
                                                </div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***707</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb lion"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***311</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb red"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;">red</span>
                                                </div>
                                                <div class="col-3 xtr">100</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***438</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb lion"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***257</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb lion"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">10000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***453</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb lion"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***269</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb lion"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">80</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***038</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb red"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;">red</span>
                                                </div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***244</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb cow"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">40000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***265</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb red"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;">red</span>
                                                </div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***826</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb cow"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***241</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb cow"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">10</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***458</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb cow"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">50000</div>
                                            </div>
                                            <div class="row pt-2 pb-2 lih-32" style="height: 48px;">
                                                <div class="col-4 xtl">{{userdetails.period}}</div>
                                                <div class="col-3 cgray">***730</div>
                                                <div class="col-2 "><span class="sm wlrcd wlb cow"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;"></span>
                                                </div>
                                                <div class="col-3 xtr">1000</div>
                                            </div>
                                        </div>
                                    </marquee>
                                </div>
                            </div>


                            <div class="col-12" id="myorder" style="display: none; color: gray;">
                                <div class="row plr-10 pb-2">
                                    <div class="col-12 pb-3 pt-2 tf-14 dflx">
                                        <div class="wd-100 xtl">Period</div>
                                        <div class="wd-36">Select</div>
                                        <div class="wd-46">Point</div>
                                        <div class="wd-36">Result</div>
                                        <div class="wd-80 xtr">Amount</div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12" id="mywod"></div>
                                    <div class="col-12" id="myod" v-for="rows in betrec" :key="rows.id" :rowsrec="rows">
                                        <div class="row plr-10">
                                            <div class="col-12 lih-32 pt-2 pb-2 dflx">
                                                <div class="wd-100 xtl">{{ rows.period }}</div>
                                                <div class="wd-36"><span :class="`sm wlrcd wlb ${rows.ans}`"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:10px; color: black;">{{
                                                            getmul(rows.ans)
                                                        }}</span>
                                                </div>
                                                <div class="wd-46">{{ rows.amount }}</div>
                                                <div class="wd-36"><span :class="`sm wlrcd wlb ${rows.fres}`"
                                                        style="width: 25px;height: 25px;line-height:25px;font-size:12px;" ><sapn v-html="getele(rows.res)"></sapn></span>
                                                </div>
                                                <div class="wd-80 xtr" v-html="betamount(rows.amount, rows.ans, rows.res)">

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="m-order"
                                            onclick="window.location.href='#/orderrecord?server=Wheelocity'">more &gt;
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-12">
                            <div class="row" id="nfrm" style="display:none;">
                                <div class="col-12 pa-0 odbox bslidein">
                                    <div :class="betclass('xsel')" id="nxsel">Join {{ betbox.title }}</div>
                                    <div class="row bfard">
                                        <div class="col-6 xtl tfcdb tf-20 tffss"><span class="tf-28" id="u_bal">{{
                                            userdetails.balance
                                        }}</span>
                                        </div>
                                        <div class="col-6 pl-0 pr-1 xtr pt-1">
                                            <div class="rc-wal" onclick="window.location.href='#/recharge'">Recharge
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mr-0 pa-10">
                                        <div class="col-12 xtl">Contract Money</div>
                                        <div class="col-12 tf-16 xtl" id="factorlist">
                                            <div :class="betclass('cont-amt selected')" id="10"
                                                @click="selectmultiply(10)">
                                                10</div>
                                            <div :class="betclass('cont-amt')" id="100" @click="selectmultiply(100)">100
                                            </div>
                                            <div :class="betclass('cont-amt')" id="1000" @click="selectmultiply(1000)">
                                                1000
                                            </div>
                                            <div :class="betclass('cont-amt')" id="10000"
                                                @click="selectmultiply(10000)">
                                                10000</div>
                                        </div>
                                    </div>
                                    <div class="row mr-0 pa-10">
                                        <div class="col-12 xtl">
                                            <div class="silb mr-2">Number</div>
                                            <div class="row">
                                                <div class="col-5 xtl pr-0"><span class="xpan" id="xm5"
                                                        @click="minus(5)">-5</span><span class="xpan" id="xm"
                                                        @click="minus(1)">-1</span></div>
                                                <div class="col-2 xtc"><span class="xnum" id="xn">{{
                                                    betbox.multiply
                                                }}</span>
                                                </div>
                                                <div class="col-5 xtr pl-0"><span class="xpan" id="xp"
                                                        @click="plus(1)">+1</span><span class="xpan" id="xp5"
                                                        @click="plus(5)">+5</span></div>
                                            </div>
                                        </div>
                                        <div class="col-12 mt-2 tf-16 xtl">Total contract money is <span id="tca">{{
                                            betbox.amount
                                        }}</span>
                                        </div>
                                    </div>
                                    <div class="row mr-0 mb-2">
                                        <div class="col-12 xtr">
                                            <div :class="betclass('btn-con newod')" id="nod" @click="confirmbet()">
                                                Confirm
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 betfbg" id="blackscreen" @click="closescreen()" style="display: none;"></div>
                        <div class="row mr-0" id="lfprd"></div>
                        <div class="row">
                            <div class="row" id="clink" style="display:none">
                                <div class="col-12 conod LR" @click="cpop()">
                                    <div class="ssmg fadein">
                                        <div class="tf-14 pb-2" id="message"> </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" id="ucheck"></div>
                            <div class="col-12" id="suc-fail"></div>
                            <div class="col-12 bbg" id="xrule" style="display: none;">
                                <div class="col-12 botfrm bslidein" style="display: block;">
                                    <div class="tf-20 mt-3 mb-3"><span class="grlm">Circle Rule</span></div>
                                    <div class="row mt-2 pb-2 tfcdb grh-60">
                                        <div class="col-12 xtl tf-16" style="color: black;">
                                            <div class="justify">Circle is a guessing game, you can choose
                                                Lion,Cow,Elephant,king,red,green,yellow.</div>
                                            <div class="justify pt-2">The wheel begins spinning after 20 seconds of
                                                order time. A color pointed by the arrow will win when the wheel stops.
                                            </div>
                                            <div class="justify pt-2">If you spend 100 to trade, after deducting 2
                                                rupees service fee, your contract amount is 98 rupees:</div>
                                        </div>

                                        <div class="col-12 tfs-b tf-14 pt-2 justify" style="color: black;">
                                            <ul class="pl-4">
                                                <li class="pt-1">Buy <b>
                                                       red
                                                    </b>: If the arrow points to RED, you will receive (95 *
                                                    18) 1710 rupees after spinning.</li>
                                                    <li class="pt-1">Buy <b>
                                                       green
                                                    </b>: If the arrow points to GREEN, you will receive (95 *
                                                    2) 190 rupees after spinning.</li>
                                                    <li class="pt-1">Buy <b>
                                                       yellow
                                                    </b>: If the arrow points to YELLOW, you will receive (95 *
                                                    2) 190 rupees after spinning.</li>
                                                    <li class="pt-1">Buy <b>
                                                       king
                                                    </b>: If the arrow points to KING, you will receive (95 *
                                                    18) 1710 rupees after spinning.</li>
                                                    <li class="pt-1">Buy <b>
                                                       cow
                                                    </b>: If the arrow points to COW, you will receive (95 *
                                                    3) 285 rupees after spinning.</li>
                                                    <li class="pt-1">Buy <b>
                                                       elephant
                                                    </b>: If the arrow points to ELEPHANT, you will receive (95 *
                                                    3) 285 rupees after spinning.</li>
                                                    <li class="pt-1">Buy <b>
                                                       lion
                                                    </b>: If the arrow points to LION, you will receive (95 *
                                                    3) 285 rupees after spinning.</li>
                                               
                                            </ul>
                                        </div>
                                        <div class="col-12 fixn">
                                            <div class="btn-con cls" @click="closerule()">I GOT IT</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="odrea"></div>
                <div class="row" id="footer"></div>
                <div class="row" id="opffp"></div>
                <div class="row" id="anof">

                </div>

            </div>
        </div>
    </section>
</template>
<script>
import axios from "axios";
export default {
    name: "WinView",
    props: ['rowsrec'],
    data() {
        return {
            isActive: false,
            userdetails: {
                username: null,
                balance: null,
                period: null,

            },
            betbox: {
                title: null,
                target: null,
                boxcolor: null,
                timeout: false,
                multiply: 1,
                factor: 10,
                amount: 10,
                page: 1,
                page1: 1,
                total: 1000,
                total1: null,

            },
            resultrec: '',
            info: '',
            betrec: ''

        }

    },
    mounted: function () {
        this.countdown();
        this.refreshcountdown = setInterval(this.countdown, 1000);
        this.start(); 
         this.fechresultrec();
    },
    beforeUnmount: function () {
        console.log("unmount");
        clearInterval(this.refreshcountdown);

    },
    created: function () {
      
        // this.expand();
    },
    methods: {
        start() {
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=result&server=Wheelocity').then((res) => {
                    this.ani = res.data[res.data.length-1].ans;
                    console.log(this.ani);
                    document.getElementById("wheel").style.transform = "rotate(" + this.ani + "deg)";
            }).catch((err) => {
                console.log(err);
            })
           
        },
        pop(message) {
            document.getElementById("message").innerHTML = message;
            document.getElementById("clink").style.display = "";

        }, cpop() {
            document.getElementById("clink").style.display = "none";

        },
        fechresultrec() {
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=result&server=Wheelocity').then((res) => {
                this.resultrec = res.data;
                console.log(this.resultrec);
            }).catch((err) => {
                console.log(err);
            })
            this.userdetails.username = localStorage.getItem('username');
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=betrec&user=' + this.userdetails.username + '&server=Wheelocity').then((res) => {
                this.betrec = res.data;
                console.log(this.betrec);
            }).catch((err) => {
                console.log(err);
            })

            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=info&user=' + this.userdetails.username + '&per=Wheelocity').then((res) => {
                this.info = res.data;
                this.betbox.total = this.info[1].total;
                this.betbox.total1 = this.info[3].total1;
                this.userdetails.balance = this.info[0].balance;
                this.userdetails.period = this.info[2].period;
                console.log(this.info);
            }).catch((err) => {
                console.log(err);
            })
        },
        betamount(x, y,z) {
            var amount;
            var f;
            if (z == "fail") {
                f = 98 / 100 * x;
                amount = "<r> -" + (f.toFixed(2)) + "</r>";
                return amount;
            } else if (z == 'success') {
                if (y == "green") {
                        f = 98 / 100 * x *2;
                        amount = "<g>+" + f.toFixed(2) + "</g>";
                        return amount;
        
                }else if (y == "red") {
                        f = 98 / 100 * x *18;
                        amount = "<g>+" + f.toFixed(2) + "</g>";
                        return amount;
                }
                else if (y == "yellow") {
                        f = 98 / 100 * x * 2;
                        amount = "<g>+" + f.toFixed(2) + "</g>";
                        return amount;
                }else if (y == "king") {
                        f = 98 / 100 * x * 18;
                        amount = "<g>+" + f.toFixed(2) + "</g>";
                        return amount;
                }else if (y == "cow") {
                        f = 98 / 100 * x * 3;
                        amount = "<g>+" + f.toFixed(2) + "</g>";
                        return amount;
                }else if (y == "lion") {
                        f = 98 / 100 * x * 3;
                        amount = "<g>+" + f.toFixed(2) + "</g>";
                        return amount;
                }else if (y == "elephant") {
                        f = 98 / 100 * x * 3;
                        amount = "<g>+" + f.toFixed(2) + "</g>";
                        return amount;
                }

            } else {
                return "<span class='icon wait'></span>";
            }
        },
        readrule() {
            document.getElementById("xrule").style.display = "";
        },
        closerule() {
            document.getElementById("xrule").style.display = "none";
        },
        join(label) {
            console.log(label);
            if (this.betbox.timeout) {
                if (label == "black") {
                    this.betbox.target = "black";
                    this.betbox.boxcolor = "black";
                    this.betbox.title = "Black";
                } else if (label == "red") {
                    this.betbox.target = "red";
                    this.betbox.boxcolor = "red";
                    this.betbox.title = "Red";
                } else if (label == "yellow") {
                    this.betbox.target = "yellow";
                    this.betbox.boxcolor = "tie";
                    this.betbox.title = "Yellow";
                } else if (label == "green") {
                    this.betbox.target = "green";
                    this.betbox.boxcolor = "green";
                    this.betbox.title = "Green";
                } else if (label == "lion") {
                    this.betbox.target = "lion";
                    this.betbox.boxcolor = "lion";
                    this.betbox.title = "Lion";
                }
                else if (label == "cow") {
                    this.betbox.target = "cow";
                    this.betbox.boxcolor = "cow";
                    this.betbox.title = "Cow";
                }
                else if (label == "elephant") {
                    this.betbox.target = "elephant";
                    this.betbox.boxcolor = "elephant";
                    this.betbox.title = "Elephant";
                }
                else if (label == "king") {
                    this.betbox.target = "king";
                    this.betbox.boxcolor = "king";
                    this.betbox.title = "King";
                }
            
                this.fechresultrec();
                document.getElementById("nfrm").style.display = "block";
                document.getElementById("blackscreen").style.display = "block";
               
            }

        },
        closescreen() {
            document.getElementById("nfrm").style.display = "none";
            document.getElementById("blackscreen").style.display = "none";
        },
        betclass(name) {
            return name + ' ' + this.betbox.boxcolor;
        },

        closebetbox() {
            //document.getElementById("betbox").style.display = "none";
            var listItems = document.getElementById('factorlist').childNodes;
            // Remove 'active' tag for all list items
            for (let i = 0; i < listItems.length; i++) {
                listItems[i].classList.remove('active');
            }
            this.betbox.amount = this.betbox.factor * this.betbox.multiply
            document.getElementById("10").className = "active";
            this.betbox.multiply = 1;
            this.betbox.factor = 10;
            this.betbox.amount = 10;
        },
        selectmultiply(multi) {
            var listItems = document.getElementById('factorlist').childNodes;
            // Remove 'active' tag for all list items
            for (let i = 0; i < listItems.length; i++) {
                listItems[i].classList.remove('selected');
            }
            this.betbox.factor = multi;
            this.betbox.amount = this.betbox.factor * this.betbox.multiply
            document.getElementById(multi).className = "cont-amt selected " + this.betbox.target;
        },
        plus(value) {
            this.betbox.multiply = this.betbox.multiply + value;
            this.betbox.amount = this.betbox.factor * this.betbox.multiply
        },
        minus(value) {
            if (this.betbox.multiply > value) {
                this.betbox.multiply = this.betbox.multiply - value;
                this.betbox.amount = this.betbox.factor * this.betbox.multiply
            }

        },
        myorder() {
            document.getElementById("every").classList.remove("active");
            document.getElementById("my").classList.add("active");
            document.getElementById("myorder").style.display = "";
            document.getElementById("everyoneorder").style.display = "none";
        },
        everyoneorder() {
            document.getElementById("my").classList.remove("active");
            document.getElementById("every").classList.add("active");
            document.getElementById("myorder").style.display = "none";
            document.getElementById("everyoneorder").style.display = "";
        },
        countdown() {
            var countDownDate = Date.parse(new Date) / 1e3;
            //var now = new Date().getTime();
            var distance = 30 - countDownDate % 30;
            //alert(distance);
            var i = distance / 60,
                n = distance % 60;

            //o = n / 10,
            // s = n % 10;
            var minutes = Math.floor(i);
            var seconds = ('0' + Math.floor(n)).slice(-2);
            var sec1 = (seconds % 100 - seconds % 10) / 10;
            var sec2 = seconds % 10;
            document.getElementById("demo").innerHTML = "<span class='cdspn'>0</span><span class='cdspn' id='fsm'> " + Math.floor(minutes) + "</span>:<span class='cdspn' id='fs0'>" + sec1 + "</span><span class='cdspn' id='fs1'>" + sec2 + "</span>";
            if (25 > distance) {

                document.getElementById("jnx2").classList.remove("disabled");
                document.getElementById("jnx3").classList.remove("disabled");
                document.getElementById("jnx50").classList.remove("disabled");
                this.betbox.timeout = true;
            }
            if (25 < distance) {
                var angle = distance * 9.5*100;
                document.getElementById("wheel").style.transform = "rotate(" + (angle) + "deg)";
                document.getElementById("wlsmg").innerHTML = "Waiting for the result";
            } else {

                document.getElementById("wlsmg").innerHTML = "Place your bets";
                
                this.start();
            }
            if (25 < distance) {

                document.getElementById("jnx2").classList.add("disabled");
                document.getElementById("jnx3").classList.add("disabled");
                document.getElementById("jnx50").classList.add("disabled");
                document.getElementById("nfrm").style.display = "none";
                document.getElementById("ev").stop();
                document.getElementById("blackscreen").style.display = "none";
                this.betbox.timeout = false;
            }
            if (30 == distance) {
                this.fechresultrec();
            }
            if (25 == distance) {
                document.getElementById("ev").start();
                document.getElementById("ev").start();
            }
            if (28 == distance) {
                this.fechresultrec();
            }
            if (29 == distance) {
                this.fechresultrec();
               
            }
            if (26 == distance) {
                this.fechresultrec();
            }

        },
        toggle(idx) {
            if (document.getElementById(idx).style.display == "") {
                document.getElementById(idx).style.display = "none";
            } else {
                document.getElementById(idx).style.display = "";
            }
        },
        confirmbet() {
            document.getElementById("nfrm").style.display = "none";
            document.getElementById("blackscreen").style.display = "none";
            if (this.userdetails.balance >= this.betbox.amount) {
                var data = new FormData();
                data.append("username", this.userdetails.username);
                data.append("period", this.userdetails.period);
                data.append("amount", this.betbox.amount);
                data.append("ans", this.betbox.target);
                axios
                    .post(
                        "https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=bet&server=Wheelocity",
                        data
                    )
                    .then(res => {
                        console.log(res.data);
                        alert("success");
                        this.closebetbox();
                        this.fechresultrec();
                        
                    })
                    .catch(err => {
                        console.log("Error", err);
                    });
                this.fechresultrec();
            } else {
                this.pop("Low Balance!");
            }

        },
        load() {
            this.fechresultrec();
        },
        getmul(stat) {
            if (stat == "red") {
                return 'red';
            } else if (stat == "green") {
                return 'green';
            } else if (stat == "yellow") {
                return 'yellow';
            } 
        },
        getele(ele) {
            if (ele == 'wait') {      
          return "<div class='GS'><div class=''></div><div class='tpr'>" + ele + "</div></div>"

            } 
        },
        short(stat) {
            if (stat == "red") {
                return 'R';
            } else if (stat == "green") {
                return 'G';
            } else if (stat == "violet") {
                return 'V';
            } else {
                return stat;
            }
        }



    }
}

</script>